import { render, staticRenderFns } from "./OsakanaTeruteru.vue?vue&type=template&id=4a090e08&scoped=true"
import script from "./OsakanaTeruteru.vue?vue&type=script&lang=js"
export * from "./OsakanaTeruteru.vue?vue&type=script&lang=js"
import style0 from "./OsakanaTeruteru.vue?vue&type=style&index=0&id=4a090e08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a090e08",
  null
  
)

export default component.exports